


































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import BackofficeAgendamentoStore from '@/components/Backoffice/Store/BackofficeAgendamentoStore'
import ReservaSalaStore from '@/components/ReservaSala/Store/ReservaSalaStore'
import SolicitacaoCancelamentoStore from '@/components/SolicitacaoCancelamento/Store/SolicitacaoCancelamentoStore'
import HistoricoSolicitacaoStore from '@/components/HistoricoSolicitacao/Store/HistoricoSolicitacaoStore'
import SolicitacaoComentariosStore from '@/components/SolicitacaoComentarios/Store/SolicitacaoComentariosStore'
import SolicitacaoPendenciaStore from '@/components/SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'

import { timeout, timeoutDefault, groupCollectionByField, maskHour } from '@/utils/common'
import { TipoUsuarioEnum,
  SituacaoEnum,
  EtapaEnum,
  CancelarSolicitacaoParam,
  TipoOrigemEnum,
  PendenciaMensagem,
  TipoMensagemEnum,
  TipoDocumentoUpload } from '@/types/_'
import { IPendenciaSolicitacao, PendenciaSolicitacao } from '@/types/implements/PendenciaSolicitacao'
import { Triagem, ITriagem } from '@/types/implements/Triagem'
import EventBus from '@/plugins/EventBus'
import moment from 'moment'

@Component
export default class ComponentModalPreAgendamento extends Vue {
  $refs!: {
    refConfirmarTriagem: any,
    modalContainer: HTMLElement
  }

  loadClose: boolean = false
  loadConfirmar: boolean = false
  loadNextStep: boolean = false
  loadCancelamento: boolean = false
  step = 1

  get area() {
    return this.$route.name
  }

  get getAutorizacaoAnexo() {
    if (this.getBackofficeGlobalStore.solicitacao.etapa.key === EtapaEnum.agendamento) {
      return {
        pedidoMedico: true,
        laudo: true,
        cotacaoOpme: true,
        laudoAnestesista: false,
        anexoOperadora: false,
      }
    }

    return {
      pedidoMedico: true,
      laudo: true,
      cotacaoOpme: true,
      laudoAnestesista: true,
      anexoOperadora: true,
    }
  }

  get getAutorizacao() {
    return (
      this.getBackofficeGlobalStore.solicitacao.situacao.key === SituacaoEnum.Autorizada
      || this.getBackofficeGlobalStore.solicitacao.situacao.key === SituacaoEnum.AutorizadaParcial
      || this.getBackofficeGlobalStore.solicitacao.situacao.key === SituacaoEnum.AutorizadaAceitaMedico
      || this.getBackofficeGlobalStore.solicitacao.situacao.key === SituacaoEnum.AguardandoOperadora
    )
  }

  get loadingClose() {
    return this.loadClose
  }

  set loadingClose(value: boolean) {
    this.loadClose = value
  }

  get loadingConfirmar() {
    return this.loadConfirmar
  }

  set loadingConfirmar(value: boolean) {
    this.loadConfirmar = value
  }

  get loadingNextStep() {
    return this.loadNextStep
  }

  set loadingNextStep(value: boolean) {
    this.loadNextStep = value
  }

  get loadingCancelamento() {
    return this.loadCancelamento
  }

  set loadingCancelamento(value: boolean) {
    this.loadCancelamento = value
  }

  get getHistoricoSolicitacaoStore() {
    return getModule(HistoricoSolicitacaoStore, this.$store)
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getBackofficeAgendamentoStore() {
    return getModule(BackofficeAgendamentoStore, this.$store)
  }

  get getPendenciaStore() {
    return getModule(SolicitacaoPendenciaStore, this.$store)
  }

  get getSolicitacaoCancelamentoStore() {
    return getModule(SolicitacaoCancelamentoStore, this.$store)
  }

  get getComentariosStore() {
    return getModule(SolicitacaoComentariosStore, this.$store)
  }

  get showModalPreAgendamento() {
    const show = this.getBackofficeGlobalStore.modal.preAgendamento
    this.toggleHtmlOverflow(show)
    this.scrollToMensagem()
    return show
  }

  set showModalPreAgendamento(val: boolean) {
    this.getBackofficeGlobalStore.setModal({
      name: 'preAgendamento',
      value: val,
    })
  }

  get canShowNextStep() {
    return this.getBackofficeGlobalStore.solicitacao.hospitalRealizaTriagemDuranteOPreAgendamento
  }

  msgCoberturaVigente: string = ''
  get mensagemCoberturaVigente() { return this.msgCoberturaVigente }
  set mensagemCoberturaVigente(value: string) { this.msgCoberturaVigente = value }

  async nextStep() {
    this.loadingNextStep = true

    const { solicitacao, componentToConfirmReservation } = this.getBackofficeGlobalStore

    // 1. Se houver mensagem de pendência a ser tratada...
    if (this.getPendenciaStore.pendencia.mensagens.length > 0) {
      this.showModalConfirmarPendencia = true
      this.loadingNextStep = false
      return
    }

    // 2. Se o paciente tem pendência de cadastro no His...
    if (componentToConfirmReservation === 'BackofficeConfirmarReservaSala' && solicitacao.temPendenciaDePaciente) {
      this.loadingNextStep = false
      const message = 'O paciente desta solicitação não está cadastrado no HIS, realize o cadastro clicando em \'BUSCAR PACIENTE\' ou \'ADICIONAR PACIENTE\''
      EventBus.$emit('setSnackbar', { show: true, text: message, icon: 'warning', color: '#C62828' })

      this.$refs.modalContainer.scrollTo({ top: 0, behavior: 'smooth' })
      return
    }

    // 3. Se o médico tem pendência de cadastro no His...
    if (componentToConfirmReservation === 'BackofficeConfirmarReservaSala' && solicitacao.temPendenciaDeMedico) {
      this.loadingNextStep = false
      const message = 'O médico desta solicitação não está cadastrado no HIS. Por favor, verifique o vínculo do médico.'
      EventBus.$emit('setSnackbar', { show: true, text: message, icon: 'warning', color: '#C62828' })

      this.$refs.modalContainer.scrollTo({ top: 300, behavior: 'smooth' })
      return
    }

    // 4. Se hospital faz consulta de cobertura vigente...
    if (solicitacao.hospital!.hospitalFazConsultaCoberturaVigente) {
      const request = await this.getBackofficeGlobalStore.consultaCoberturaVigenteBackoffice()
      if (request.success) this.getBackofficeGlobalStore.setModal({ name: 'erroCoberturaVigente', value: !request.data.temCoberturaVigente })
      this.loadingNextStep = false
      return
    }

    // 5. Se o próximo passo requer um componente de reserva de sala ou não...
    if (componentToConfirmReservation === 'BackofficeConfirmarReservaSala') {
      await this.$refs.refConfirmarTriagem.loadReservaDeSala()
    }

    this.step = this.step + 1
    this.loadingNextStep = false
  }

  get getReservaSalaStore() {
    return getModule(ReservaSalaStore, this.$store)
  }

  backStep() {
    this.getReservaSalaStore.clearReservaSalasResource()
    this.getReservaSalaStore.clearReservaSalaEvent()
    this.step = this.step - 1
  }

  async confirmarPreAgendamento() {
    this.loadingConfirmar = true

    // If the flag hospitalRealizaTriagemDuranteOPreAgendamento is true
    // Needs validate reservation date and reservation number
    if (this.getBackofficeGlobalStore.solicitacao.hospitalRealizaTriagemDuranteOPreAgendamento) {
      const reservationDateIsValid = this.$refs.refConfirmarTriagem.$refs.confirmarTriagemRule.validate()

      let isRevervationNumberValid = true
      if (this.getBackofficeGlobalStore.solicitacao.hospital
        && this.getBackofficeGlobalStore.solicitacao.hospital.exigeNumeroReserva) {
        isRevervationNumberValid = await this.$refs.refConfirmarTriagem.checkNumeroReserva()
      }

      if (!reservationDateIsValid) {
        this.loadingConfirmar = false
        return
      }

      if (!isRevervationNumberValid) {
        this.loadingConfirmar = false
        return
      }
    }

    if (this.getPendenciaStore.pendencia.mensagens.length > 0) {
      this.showModalConfirmarPendencia = true
    } else {
      let reservaDeSala: any = null

      if (this.getBackofficeGlobalStore.solicitacao.hospitalFazReservaDeSala) {
        this.getBackofficeGlobalStore.setNumeroAgendamento(this.getReservaSalaStore.reservaSalaInfo.numeroAgendamento)
        const { id, numeroAgendamento, tempoCirurgia, hospitalFazReservaDeSala } = this.getBackofficeGlobalStore.solicitacao
        const { surgeryDate, timeStart } = this.$refs.refConfirmarTriagem

        reservaDeSala = {
          salaId: this.getReservaSalaStore.roomChecked.data.id,
          centroCirurgicoId: this.getReservaSalaStore.surgeryCenter.data.id,
          solicitacaoId: id,
          numeroAgendamento: !['', undefined, null].includes(numeroAgendamento) ? numeroAgendamento : '',
          dataAgendamentoVirtual: this.getReservaSalaStore.reservaSalaInfo.dataAgendamentoVirtual,
          data: surgeryDate,
          hora: timeStart,
          tempoCirurgia,
          hospitalFazReservaDeSala,
        }

        Object.entries(reservaDeSala).forEach(([key, value]) => {
          if (['', null, undefined].includes(value as any)) delete reservaDeSala[key]
        })
      }

      const response = await this.getBackofficeGlobalStore.backofficeAgendamentoRealizaPreAgendamento(reservaDeSala)

      if (response === false) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Ocorreu um erro na requisição.', icon: 'warning', color: '#C62828' })
        return
      }

      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: `Pré-agendamento confirmado com sucesso! ${String.fromCodePoint(0x1f642)}`, icon: 'done', color: '#2E7D32' })
        await this.closeModal()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message ? `${response.message} ${String.fromCodePoint(0x1f615)}` : `Ocorreu um problema com essa requisição. ${String.fromCodePoint(0x1f615)}`, icon: 'warning', color: '#C62828' })
        await this.$refs.refConfirmarTriagem.loadReservaDeSala() // Carrega a reserva de sala novamente, porque o erro pode ter sido de conflito de horário
      }
    }

    this.loadingConfirmar = false
  }

  async closeModal() {
    this.loadingClose = true
    let solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    await this.getBackofficeGlobalStore.desbloquearSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
    await this.getBackofficeGlobalStore.closeModalPreAgendamento()
    await this.getBackofficeAgendamentoStore.loadAgendamentosMedicoSearch(solicitacaoId)
    this.getBackofficeGlobalStore.setDisableCancelarSolicitacaoButton(false)
    this.getPendenciaStore.clearPendencia()
    this.getReservaSalaStore.clearReservaSalasResource()
    this.getReservaSalaStore.clearReservaSalaEvent()
    this.getReservaSalaStore.resetReservaSalaInfoApi()
    this.getReservaSalaStore.clearSurgeryCenter()
    this.getReservaSalaStore.clearRoomChecked()
    this.getReservaSalaStore.clearCentrosCirurgicos()
    solicitacaoId = ''
    this.loadingClose = false
    this.getBackofficeGlobalStore.setCoberturaVigenteMensagem('')
  }

  async showModalCancelamento() {
    this.loadingCancelamento = true
    await timeoutDefault()
    const cancelarSolicitacaoParam: CancelarSolicitacaoParam = {
      solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
      tipoOrigem: TipoOrigemEnum.Agendamento,
      situacao: this.getBackofficeGlobalStore.solicitacao.situacao,
      canceladoMotivo: {
        display: '',
        key: '',
      },
      modal: 'triagem',
    }

    if (this.getBackofficeGlobalStore.solicitacao.canceladoMotivo) {
      cancelarSolicitacaoParam.canceladoMotivo = this.getBackofficeGlobalStore.solicitacao.canceladoMotivo
    }

    this.getSolicitacaoCancelamentoStore.setCancelarSolicitacaoParam(cancelarSolicitacaoParam)
    this.getSolicitacaoCancelamentoStore.setShowModalCancelamentoTriagem(true)
    await this.getSolicitacaoCancelamentoStore.getMotivosCancelamentoAll({ hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId })
    this.loadingCancelamento = false
  }

  toggleHtmlOverflow(isOpen: Boolean) {
    const html = document.querySelector('html')
    const noOverflowClass = 'modal-is-open'

    if (html !== null) {
      html.classList.remove(noOverflowClass)
      if (isOpen) {
        html.classList.toggle(noOverflowClass)
        document.getElementsByClassName('v-dialog')[0].scrollTop = 0
      }
    }
  }

  scrollToMensagem() {
    const ele = document.getElementsByClassName('scroll_top_visualizacao')
    if (ele.length > 0) {
      ele[0].scrollTo(0, 0)
    }
  }

  mounted() {
    EventBus.$on('abrirPendenciaAutomatica', (value: string) => {
      if (value === 'preAgendamento') {
        this.showModalPendencia = true
        this.getMensagem = this.getBackofficeGlobalStore.coberturaVigenteMensagem
      }
    })
    EventBus.$on('limparPendenciaAutomatica', (value: boolean) => this.getBackofficeGlobalStore.setCoberturaVigenteMensagem(''))
  }

  tipoUsuario: TipoUsuarioEnum = TipoUsuarioEnum.Hospital
  pendenciaSolicitacao: IPendenciaSolicitacao = new PendenciaSolicitacao()
  triagem: ITriagem = new Triagem()
  mensagem: string = ''
  inputFiles: any[] = []

  loadUpload: boolean = false
  loadPendencia: boolean = false
  loadHistorico: boolean = false
  loadComentarios: boolean = false
  modalPendencia: boolean = false
  modalConfirmarPendencia: boolean = false
  loadConfirmarPendencia: boolean = false
  loadCloseConfirmarPendencia: boolean = false
  loadClosePedencia: boolean = false
  loadMensagem: boolean = false

  async showHistory() {
    this.loadingHistorico = true
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    await this.getHistoricoSolicitacaoStore.getHistoricoSolicitacao(
      solicitacaoId,
    )
    this.loadingHistorico = false
  }

  async showComentario() {
    this.loadingComentarios = true
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    await this.getComentariosStore.getComentariosBySolicitacaoId(solicitacaoId)
    this.getComentariosStore.setShowModalComentario(true)
    this.loadingComentarios = false
  }

  async pendencia() {
    this.loadingPendencia = true
    await timeout(800)
    this.showModalPendencia = true
    this.loadingPendencia = false
  }

  async confirmarPendencia() {
    this.loadingConfirmarPendencia = true

    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    const { mensagens } = this.getPendenciaStore.pendencia
    const response = await this.pendenciaSolicitacao.abrirMensagem(
      solicitacaoId,
      mensagens,
    )

    if (response.success) {
      this.getBackofficeAgendamentoStore.deleteSolicitacao(
        this.getBackofficeGlobalStore.solicitacao.id,
      )
      this.closeModal()
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message || 'Houve um erro ao enviar a pendência.',
        icon: 'warning',
        color: '#C62828',
      })
    }

    await timeout(2000)
    this.loadingConfirmarPendencia = false
  }

  groupByDate(value: any) {
    return groupCollectionByField(value)
  }

  formatHour(value: string) {
    return maskHour(value)
  }

  async sendMensagem() {
    this.loadingMensagem = true
    await timeoutDefault()

    const time = moment().format('YYYY-MM-DDTHH:mm')
    const pendenciaMensagem: PendenciaMensagem = {
      mensagemHospital: true,
      id: '',
      dataEnvio: time,
      tipoMensagem: TipoMensagemEnum.Texto,
      texto: this.getMensagem,
    }

    this.getPendenciaStore.setPendenciaMensagem(pendenciaMensagem)
    this.getMensagem = ''
    this.loadingMensagem = false
  }

  async inputFileAgendamento(newFile, oldFile) {
    this.loadingUpload = true
    if (newFile.identifier) {
      return
    }

    const form = new FormData()
    form.append('laudos', newFile.file)
    const time = moment().format('YYYY-MM-DDTHH:mm:ss')

    const param: any = {
      hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
      tipoDocumento: TipoDocumentoUpload.PendenciaHospital,
      formData: form,
    }

    const response = await this.getPendenciaStore.uploadDocumento(param)

    if (response.success) {
      const result = response.data[0]
      const documentoId = result.id
      const { url } = result
      const { nomeArquivo } = result

      const pendenciaMensagem: PendenciaMensagem = {
        mensagemHospital: true,
        id: documentoId,
        dataEnvio: time,
        tipoMensagem: TipoMensagemEnum.Documento,
        texto: '',
        documentoId,
        url,
        nomeArquivo,
      }

      this.getPendenciaStore.setPendenciaMensagem(pendenciaMensagem)
    }

    this.loadingUpload = false
  }

  clearMensagem() {
    this.getPendenciaStore.clearMensagem()
  }

  async closeModalPendencia() {
    this.loadingClosePendencia = true
    await timeoutDefault()
    this.showModalPendencia = false
    this.loadingClosePendencia = false
  }

  async closeModalConfirmarPendencia() {
    this.loadingCloseConfirmarPendencia = true
    await timeoutDefault()
    this.showModalConfirmarPendencia = false
    this.loadingCloseConfirmarPendencia = false
  }

  get getMensagens() {
    return this.getPendenciaStore.pendencia.mensagens
  }

  get getTipoMensagemEnum() {
    return TipoMensagemEnum
  }

  get loadingClosePendencia() {
    return this.loadClosePedencia
  }

  set loadingClosePendencia(value: boolean) {
    this.loadClosePedencia = value
  }

  get loadingCloseConfirmarPendencia() {
    return this.loadCloseConfirmarPendencia
  }

  set loadingCloseConfirmarPendencia(val: boolean) {
    this.loadCloseConfirmarPendencia = val
  }

  get loadingConfirmarPendencia() {
    return this.loadConfirmarPendencia
  }

  set loadingConfirmarPendencia(val: boolean) {
    this.loadConfirmarPendencia = val
  }

  get showModalConfirmarPendencia() {
    return this.modalConfirmarPendencia
  }

  set showModalConfirmarPendencia(value: boolean) {
    this.modalConfirmarPendencia = value
  }

  get loadingUpload() {
    return this.loadUpload
  }

  set loadingUpload(val: boolean) {
    this.loadUpload = val
  }

  get loadingMensagem() {
    return this.loadMensagem
  }

  set loadingMensagem(val: boolean) {
    this.loadMensagem = val
  }

  get getMensagem() {
    return this.mensagem
  }

  set getMensagem(texto: string) {
    this.mensagem = texto
  }

  get getDisplayPendencia() {
    return {
      nomePaciente: this.getBackofficeGlobalStore.solicitacao.paciente.nome,
      nomeMedico:
        this.getBackofficeGlobalStore.solicitacao.medicoSolicitante.nome,
    }
  }

  get loadingPendencia() {
    return this.loadPendencia
  }

  set loadingPendencia(value: boolean) {
    this.loadPendencia = value
  }

  get loadingHistorico() {
    return this.loadHistorico
  }

  set loadingHistorico(value: boolean) {
    this.loadHistorico = value
  }

  get loadingComentarios() {
    return this.loadComentarios
  }

  set loadingComentarios(value: boolean) {
    this.loadComentarios = value
  }

  get showModalPendencia() {
    return this.modalPendencia
  }

  set showModalPendencia(value: boolean) {
    this.modalPendencia = value
  }

  @Watch('showModalPreAgendamento')
  onChangeShowModalPreAgendamento(value: boolean) {
    if (!value) this.step = 1
  }
}
